<template>
  <div>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#039BE5">
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <a href="/">
          <v-img
            src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/smartclub247_512x512"
            height="100"
            width="200"
          ></v-img>
        </a>
      </v-toolbar-title>

      <v-spacer />
      <div class="mx-5">
        <v-badge dark :content="cartLength" :value="cartLength" color="green" overlap>
          <v-icon dark @click="goTo('/cart')" size="30">fas fa-shopping-cart</v-icon>
        </v-badge>
      </div>
    </v-app-bar>
    <!-- TOOLBAR -->
    <v-flex xs12 md12 lg12>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="2">
          <v-card outlined>
            <v-card-text>
              <v-row>
                <!-- <v-col class="pa-0 ml-3">
                  <v-avatar tile color="black">
                    <v-icon dark>fas fa-user-secret</v-icon>
                  </v-avatar>
                </v-col>-->
                <v-col class="pa-0 name-margin">
                  <div class="mx-3">
                    <b>{{ dataUser.nama }}</b>
                  </div>
                </v-col>
              </v-row>
              <div class="my-4">
                <v-divider></v-divider>
              </div>

              <div class="my-5 text--primary">
                <v-icon class="mr-4" size="20">fas fa-money-bill-wave</v-icon>
                <span class="link-saldo">Saldo</span>
                <span class="saldo-amount">
                  {{
                  dataUser.saldo | currency
                  }}
                </span>
              </div>
              <v-divider></v-divider>
              <div v-if="dataUser.nama_toko == null">
                <v-btn @click="daftarToko = true" class="my-5" outlined block>Buka Toko</v-btn>
              </div>
              <v-dialog v-model="daftarToko" width="500">
                <v-card>
                  <v-card-title class="headline grey lighten-2" primary-title>
                    Daftar Toko
                    <v-spacer></v-spacer>
                    <v-btn @click="daftarToko = false" icon color="#B0BEC5">
                      <v-icon>fas fa-times-circle</v-icon>
                    </v-btn>
                  </v-card-title>
                  <div class="pa-5">
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field
                        v-model="namaToko"
                        :counter="25"
                        :rules="[(v) => !!v || 'Tidak boleh kosong']"
                        label="Nama Toko"
                        hint="Nama tidak bisa diubah lagi"
                        :persistent-hint="true"
                        required
                        outlined
                      ></v-text-field>
                      <v-row>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            readonly
                            :value="dataUser.handphone"
                            :v-model="dataUser.handphone"
                            :rules="[(v) => !!v || 'Tidak boleh kosong']"
                            label="Nomor HP"
                            hint="Nomor otomatis dari yang di daftarkan"
                            :persistent-hint="true"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <div v-if="verifikasi == false" class="my-auto">
                            <v-btn @click="reqOtp(dataUser.handphone)" small outlined>Verifikasi</v-btn>
                            <div v-if="verifikasi == false">
                              <v-chip class="my-2" color="#E53935" label text-color="white">
                                <v-icon small left>fas fa-times</v-icon>Unverified
                              </v-chip>
                            </div>
                          </div>
                          <div v-if="verifikasi == true">
                            <v-chip class="my-3" color="#43A047" label text-color="white">
                              <v-icon small left>fas fa-check</v-icon>Verified
                            </v-chip>
                          </div>
                        </v-col>
                      </v-row>
                      <div v-if="otp == true">
                        <v-row>
                          <v-col>
                            <v-text-field
                              outlined
                              v-model="requestOTP"
                              :rules="[(v) => !!v || 'Tidak boleh kosong']"
                              label="Kode OTP"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <v-btn @click="otpVerifikasi(nohp)" text small>Verifikasi</v-btn>
                          </v-col>
                        </v-row>
                      </div>

                      <v-text-field
                        outlined
                        v-model="alamatToko"
                        :rules="[(v) => !!v || 'Tidak boleh kosong']"
                        label="Alamat Toko"
                        required
                      ></v-text-field>
                      <v-row>
                        <v-col cols="6">
                          <v-autocomplete
                            v-if="subDistrict"
                            v-model="kecamatan"
                            :rules="[(v) => !!v || 'Wajib di isi']"
                            :items="subDistrict"
                            item-text="Name"
                            item-value="Id"
                            label="Kota atau Kecamatan"
                            flat
                            hide-no-data
                            hide-details
                            outlined
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="kodepos"
                            :rules="[(v) => !!v || 'Kodepos is required']"
                            type="text"
                            label="Kodepos"
                            required
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="1">
                          <v-checkbox
                            v-model="syarat"
                            :rules="[
                          (v) => !!v || 'Anda wajib menyetujui S&K Smart247.id',
                        ]"
                            required
                          ></v-checkbox>
                        </v-col>
                        <v-col>
                          <span class="syarat">
                            Dengan ini Saya menyetujui segala
                            <a
                              class="terms"
                              @click="terms()"
                            >Syarat & Ketentuan</a> yang ada pada website
                            <br />(Privacy, Information Security, Product Description, Shipping, Billing, Refund & Credits, Customer Services Access)
                          </span>
                        </v-col>
                      </v-row>
                    </v-form>
                  </div>
                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="buatToko(dataUser)">Buat Toko</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-divider></v-divider>
              <div v-if="dataUser.nama_toko != null">
                <div class="my-5">
                  <v-row>
                    <!-- <v-col class="pa-0 ml-3">
                      <v-avatar tile color="black">
                        <v-icon dark>fas fa-store-alt</v-icon>
                      </v-avatar>
                    </v-col>-->
                    <v-col class="pa-0 name-margin">
                      <div class="mx-3">
                        Toko .
                        <b>{{ dataUser.nama_toko }}</b>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <v-divider></v-divider>
                <div class="my-5 text--primary">
                  <v-icon class="mr-4" size="20">fas fa-book-open</v-icon>
                  <span class="link-saldo">Omset</span>
                  <span class="saldo-amount">Rp0</span>
                </div>
              </div>
              <v-divider></v-divider>
            </v-card-text>
            <v-list v-if="dataUser.nama_toko != null" dense>
              <template v-for="item in menu_toko">
                <v-row v-if="item.heading" :key="item.heading" align="center">
                  <v-col cols="6">
                    <v-subheader v-if="item.heading">
                      {{
                      item.heading
                      }}
                    </v-subheader>
                  </v-col>
                </v-row>
                <v-list-group
                  v-else-if="item.children"
                  :key="item.text"
                  v-model="item.model"
                  :prepend-icon="item.model ? item.icon : item['icon-alt']"
                  append-icon
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item v-for="(child, i) in item.children" :key="i" link>
                    <v-list-item-action v-if="child.icon">
                      <!-- <v-icon small>{{ child.icon }}</v-icon> -->
                    </v-list-item-action>
                    <v-list-item-content @click="page(child.page)">
                      <v-list-item-title>{{ child.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
                <v-list-item @click="goTo(item.id)" v-else :key="item.text" link>
                  <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
            <!-- BATAS MENU TOKO DAN USER -->
            <v-list dense>
              <template v-for="item in items">
                <v-row v-if="item.heading" :key="item.heading" align="center">
                  <v-col cols="6">
                    <v-subheader v-if="item.heading">
                      {{
                      item.heading
                      }}
                    </v-subheader>
                  </v-col>
                </v-row>
                <v-list-group
                  v-else-if="item.children"
                  :key="item.text"
                  v-model="item.model"
                  :prepend-icon="item.model ? item.icon : item['icon-alt']"
                  append-icon
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item v-for="(child, i) in item.children" :key="i" link>
                    <v-list-item-action v-if="child.icon">
                      <!-- <v-icon small>{{ child.icon }}</v-icon> -->
                    </v-list-item-action>
                    <v-list-item-content @click="page(child.page)">
                      <v-list-item-title>{{ child.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
                <v-list-item @click="goTo(item.id)" v-else :key="item.text" link>
                  <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="8">
          <ProfileUser v-if="pages == 0" />
          <Ulasan v-if="pages == 1" />
          <MenungguPembayaran v-if="pages == 2" />
          <DaftarTransaksi v-if="pages == 3" />
          <MenungguKonfirmasi v-if="pages == 9" />
          <!-- URUSAN TOKO -->
          <Penjualan v-if="pages == 4" />
          <AddProduct v-if="pages == 5" />
          <Pesanan v-if="pages == 6" />
          <Dikirim v-if="pages == 10" />
          <DaftarBarang v-if="pages == 7" />
          <DaftarToko v-if="pages == 8" />
          <!-- <v-card height="2" color="black"></v-card> -->
        </v-col>
      </v-row>
    </v-flex>
    <!-- <v-dialog v-model="otp" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Kode OTP</v-card-title>
        <div class="text-center">Masukkan Kode OTP</div>
       
        <div class="pa-5">
          <v-text-field v-model="requestOTP" label="Kode OTP" outlined></v-text-field>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="otpVerifikasi()">Verifikasi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>-->
  </div>
</template>
<script>
import Swal from "sweetalert2";
import ProfileUser from "../../components/User/ProfileUser";
import Ulasan from "../../components/User/Ulasan";
import MenungguPembayaran from "../../components/User/MenungguPembayaran";
import DaftarTransaksi from "../../components/User/DaftarTransaksi";
import MenungguKonfirmasi from "../../components/User/MenungguKonfirmasi";
// TOKO SAYA
import Penjualan from "../../components/TokoSaya/Penjualan";
import AddProduct from "../../components/TokoSaya/AddProduct";
import Pesanan from "../../components/TokoSaya/Pesanan";
import Dikirim from "../../components/TokoSaya/Dikirim";
import DaftarBarang from "../../components/TokoSaya/DaftarBarang";
import DaftarToko from "../../components/TokoSaya/DaftarToko";
export default {
  components: {
    ProfileUser,
    Ulasan,
    MenungguPembayaran,
    DaftarTransaksi,
    Penjualan,
    AddProduct,
    Pesanan,
    DaftarBarang,
    DaftarToko,
    MenungguKonfirmasi,
    Dikirim
  },
  data() {
    return {
      requestOTP: null,
      otp: false,
      daftarToko: false,
      syarat: false,
      namaToko: "",
      alamatToko: "",
      nohp: null,
      kecamatan: "",
      kodepos: "",
      valid: true,
      verifikasi: false,
      pages: this.$route.params.id,
      subDistrict: [],
      cartLength: null,
      dataUser: [],
      userid: localStorage.getItem("user_id"),
      token: localStorage.getItem("token"),
      idkeranjang: localStorage.getItem("idkeranjang"),
      items: [
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "PEMBELIAN",
          model: true,
          children: [
            { text: "Menunggu Pembayaran", page: 2 },
            { text: "Menunggu Konfirmasi", page: 9 },
            { text: "Daftar Transaksi", page: 3 }
          ]
        },

        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "PROFIL SAYA",
          model: true,
          children: [
            { text: "Wishlist", page: 0 },
            { text: "Toko Favorit", page: 8 },
            { text: "Pengaturan", page: 0 }
          ]
        }
      ],
      menu_toko: [
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "TOKO SAYA",
          model: true,
          children: [
            { text: "Penjualan", page: 4 },
            { text: "Pesanan", page: 6 },
            { text: "Dikirim", page: 10 },
            { text: "Tambah Produk", page: 5 },
            { text: "Daftar Produk", page: 7 },
            { text: "Pengaturan Toko", page: 0 }
          ]
        }
      ]
    };
  },
  mounted() {
    if (this.token == null) {
      this.$router.push("/login");
    } else {
      this.getDataUser();
      this.getCart();
      this.getKecamatan();
    }
  },
  watch: {
    provinsi(newVal) {
      console.log(newVal);
      this.getKota(newVal);
    },
    verifikasi(val) {
      if (val == true) {
        this.verifikasi = val;
      }
    },
    valid(val) {
      if (val == true) {
        this.valid = val;
      }
    }
  },
  methods: {
    terms() {
      window.open("#/terms");
    },
    page(id) {
      this.$router.push("/account/" + id);
      window.location.reload();
    },
    getDataUser() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/ViewUser/" +
          localStorage.getItem("user_id")
      )
        .then(response => response.json())
        .then(data => {
          this.dataUser = data;
          localStorage.setItem("nama_toko", data.nama_toko);
        });
    },
    getCart() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/checkoutpro/" +
          this.idkeranjang +
          "/1000"
      )
        .then(response => response.json())
        .then(data => {
          if (data.keranjang != null) {
            this.carts = data.keranjang;
            var x = this.carts.length;
            if (x > 0) {
              this.cartHeader = x;
            } else {
              this.cartHeader = 0;
            }

            this.overlay = false;
          } else {
            this.cartHeader = 0;
            this.overlay = false;
          }
        });
    },
    getKecamatan() {
      fetch("http://meridinet.saebo.id:2082/Login/api/viewkecamatan")
        .then(response => response.json())
        .then(data => {
          this.subDistrict = data;
        });
    },
    goTo(e) {
      this.$router.push(e);
    },
    validate() {
      this.$refs.form.validate();
    },
    buatToko(data) {
      if (this.$refs.form.validate() && this.verifikasi == true) {
        fetch("http://meridinet.saebo.id:2082/Login/api/tabel/updusers", {
          method: "POST",
          body: JSON.stringify({
            user_id: this.userid,
            nama_toko: this.namaToko
          }),
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            Swal.fire("Sukses!", "Toko dibuat! Semoga Sukses", "success");
          });
        fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addalamat", {
          method: "POST",
          body: JSON.stringify({
            userid: this.id,
            nama: null,
            nama_alamat: "Toko",
            alamat: this.alamat,
            handphone: null,
            subdistrict_id: this.kecamatan,
            kodepos: this.kodepos,
            status: "LAINNYA",
            penerimahp: data.handphone,
            penerima: data.nama
          }),
          headers: {
            "Content-type": "application/json"
          }
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          });
      } else if (this.verifikasi == false) {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Nomor belum di verifikasi"
        });
      }
    },
    reqOtp(data) {
      this.overlay = true;
      this.otp = true;
      console.log(data);
      localStorage.setItem("nohpOTP", data);
      fetch("http://saebo.technology/apisms/capi/regis/" + data + "/incenter")
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data == "success") {
            this.overlay = false;
            Swal.fire("Sukses", "OTP telah dikirim!", "success");
          }
        });
    },
    otpVerifikasi(data) {
      this.overlay = true;
      console.log(data);
      var x = localStorage.getItem("nohpOTP");
      fetch(
        "http://saebo.technology/apisms/capi/cek/" + x + "/" + this.requestOTP
      )
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data == "success") {
            // this.otp = false;
            this.verifikasi = true;
            Swal.fire("Good job!", "Verifikasi berhasil !", "success");
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text: "Kode OTP Expired"
            });
          }

          this.overlay = false;
        });
    }
  }
};
</script>
<style scoped>
.terms {
  color: #a28940;
  text-decoration: underline solid rgb(68, 68, 68);
}
.syarat {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 85%;
  letter-spacing: 0px;
  word-spacing: 0px;
  color: #9d9d9d;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.name-margin {
  margin-right: 13%;
}
.link-saldo {
  color: green;
}
.saldo-amount {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: -1px;
  word-spacing: 2px;
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  float: right;
}
</style>
